export const subPartner = {
    default: {
        redirectUrl: process.env.REACT_APP_ADVISORY_URL,
    },
    ICMP004: {
        redirectUrl: "https://onboarding.incredvalueplus.com",
    }
}